<template>
  <div>
    <b-modal
      v-model="modalAnniversary"
      id="anniversary25-modal"
      size="lg"
      class="customModal"
      title=""
      @close="modalAnniversary = false"
      @ok="modalAnniversary = false"
      @hide="!modalAnniversary"
      ok-only
      no-close-on-esc
      no-close-on-backdrop
    >
      <h5 class="pb-3 font-weight-bold font-size-22">PODZIĘKOWANIA</h5>
      <div class="font-size-17">
        <p>
          <span style="color: #dedd49"
            >Z okazji
            <strong
              >25-lecia korzystania z programu SKP<sup>®</sup></strong
            ></span
          ><br />
          pragniemy złożyć serdecznie podziękowania za wieloletnią współpracę.
        </p>
        <p>
          Jednocześnie zapraszamy do dalszego korzystania z naszego programu
          w&nbsp;kolejnym&nbsp;roku&nbsp;kalendarzowym, w którym to przyznaliśmy
          Państwu
          <strong>
            <br /><span style="color: #dedd49"
              >50% RABAT na Opiekę Serwisową.</span
            ><br />
          </strong>
        </p>
        <p>Wejdź do menu: Opieka Serwisowa i zamów z rabatem.</p>
        <p class="text-right">
          Z wyrazami szacunku,<br />
          Zespół FORMSOFT sp. z o.o.
        </p>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import Cookies from '../../helper/cookiesHelper';

export default {
  name: 'Home',
  data() {
    return {
      modalAnniversary: false,
    };
  },
  computed: {
    ...mapGetters({
      program: 'getProgram',
      client: 'auth/client',
      currentOs: 'auth/currentOs',
    }),
  },
  mounted() {
    if (
      this.program == 'skp' &&
      !this.currentOs &&
      Cookies.getCookie('modal25Anniversary') < 2
    ) {
      let clientYears =
        moment().format('YYYY') - moment(this.client.SPR).format('YYYY');
      if (
        this.client.K == '1' &&
        this.client.M != '1' &&
        [1, 2, 3].includes(this.client.L) &&
        [25].includes(clientYears)
      ) {
        this.modalAnniversary = true;
        Cookies.setCookie(
          'modal25Anniversary',
          !Cookies.getCookie('modal25Anniversary')
            ? 1
            : parseInt(Cookies.getCookie('modal25Anniversary')) + 1,
          60 * 60 * 24 * 300
        );
      }
    }
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  #anniversary25-modal___BV_modal_content_ {
    background: #1191a7;
    color: #fff;
    text-align: center;

    #anniversary25-modal___BV_modal_header_ {
      text-align: center;
      display: block;
      border: none;
      padding: 0.2rem 0.5rem 0 0;
    }

    #anniversary25-modal___BV_modal_body_ {
    }

    #anniversary25-modal___BV_modal_footer_ {
      display: none;
    }
  }
}
</style>
